import React, {useContext} from "react";
import {ReactKeycloakProvider} from "@react-keycloak/web";
import Keycloak from "keycloak-js";
import axiosInstance from "../../../common/src/api/AxiosInstance";
import {UserContext} from "../context/UserContext"

const isAuthDisabled = window._env_?.disableAuth === true;

// Stand-in for keycloak-js satisfying the subset of the API @react-keycloak/web and this app
// actually call, so local dev shows an already-authenticated user (and the CSV/Preview buttons
// that gate on it) without a real Keycloak login.
class LocalMockKeycloak {
    constructor() {
        this.authenticated = true;
        this.token = "local-dev-token";
        this.idToken = "local-dev-id-token";
        this.refreshToken = "local-dev-refresh-token";
        this.tokenParsed = {
            sub: "local-dev-user",
            name: "Local Dev",
            given_name: "Local",
            family_name: "Dev",
            realm_access: {roles: []},
        };
    }

    init() {
        return Promise.resolve().then(() => {
            this.onReady && this.onReady(this.authenticated);
            this.onAuthSuccess && this.onAuthSuccess();
            return this.authenticated;
        });
    }

    updateToken() {
        return Promise.resolve(false);
    }

    login() {
        console.info("[local-dev] mock Keycloak login() is a no-op (window._env_.disableAuth)");
    }

    logout() {
        console.info("[local-dev] mock Keycloak logout() is a no-op (window._env_.disableAuth)");
    }
}

if (isAuthDisabled) {
    console.warn("[local-dev] Keycloak auth is DISABLED (window._env_.disableAuth) — using a mock logged-in user.");
}

const keycloak = isAuthDisabled
    ? new LocalMockKeycloak()
    : new Keycloak({
        url: "/auth",
        realm: window._env_.realm,
        clientId: window._env_.clientId
    });

const Auth = (props) => {
    const {user, setUser} = useContext(UserContext); //accessToken
    const [initialized, setInitialized] = React.useState(false);
    const initialOptions = {
        onLoad: 'check-sso',
        pkceMethod: 'S256',
        enableLogging: false,
        silentCheckSsoFallback: false,
        fallbackCheckLoginIframe: false,
        checkLoginIframe: false,
        checkLoginIframeInterval: 30,
    }

    keycloak.onAuthRefreshError = () => {
        console.log('onAuthError')
        setUser({
            hasLoaded: !user?.hasLoaded
        });
        // window.location.href = '/'; // Redirect to a custom login or session-expired page
    };
    const onTokens = (tokens) => {

         const userData = {
            id: keycloak?.tokenParsed?.sub,
            accessToken: tokens?.token,
            firstName: keycloak?.tokenParsed?.given_name,
            lastName: keycloak?.tokenParsed?.family_name,
            roles: keycloak?.tokenParsed?.realm_access?.roles,
            hasLoaded: false
        }

        axiosInstance.setAuthToken(tokens?.token ?? null);
        setUser({
            ...userData,
            hasLoaded: !!tokens?.token
        });
    }

    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={initialOptions}
            onTokens={onTokens}

            LoadingComponent={<div/>}
            isLoadingCheck={() => (!user && !initialized && !keycloak?.didInitialize) || (!initialized && user?.hasLoaded && !keycloak.authenticated && !keycloak?.didInitialize)}
            onAuthLogout={() => {
                setUser({hasLoaded: false});
                document.cookie = "connect.sid=; Max-Age=0; path=/;"; // Replace with actual cookie names if needed
            }}
            onReady={auth => {
                if (auth?.authenticated) {
                    setInitialized(true);
                } else {
                    setInitialized(true);
                    setUser({hasLoaded: true});
                }
            }}
        >
            {props.children}
        </ReactKeycloakProvider>
    )
}

export default Auth;
